var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { initialHistoryPoints } from "../loyaltyCore";
export const fetchPointsHistory = createAsyncThunk("loyaltyCore/fetchPointsHistory", ({ perPage, pageNo }, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const loyaltyApi = LoyaltyApi.init();
    const user = getUser();
    if ((user === null || user === void 0 ? void 0 : user.uuid) && (user === null || user === void 0 ? void 0 : user.ciam_token) && perPage && pageNo) {
        try {
            const result = yield loyaltyApi.getPointsHistory(user.uuid, user.ciam_token, perPage, pageNo);
            return Object.assign(Object.assign({}, result), { isLoaded: true });
        }
        catch (error) {
            if (typeof error === "object" && error !== null) {
                const { message, statusCode } = error;
                if (typeof message === "string" && typeof statusCode === "number") {
                    return rejectWithValue({ message, code: statusCode });
                }
            }
            return rejectWithValue({ message: "An unknown error occurred", code: 0 });
        }
    }
    return initialHistoryPoints;
}));
//# sourceMappingURL=fetchPointsHistory.js.map